export default {"src":"/_next/static/media/start.8611b8b1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};